import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./scss/index.scss";
import { usePreferences } from "@hooks";
import * as React from "react";
import { useIntl } from "react-intl";
import { Overlay } from "../..";
import iconImg from "../../../images/info.svg";

var DimensionPopup = function DimensionPopup(_ref) {
  var overlay = _ref.overlay;
  var intl = useIntl();

  var _usePreferences = usePreferences(),
      preferences = _usePreferences.preferences,
      setPreferences = _usePreferences.setPreferences;

  var clickHandler = function clickHandler() {
    overlay.hide();
  };

  preferences.showDimensionPopup = false;
  setPreferences(preferences);
  return React.createElement(Overlay, {
    context: overlay
  }, React.createElement("div", {
    className: "popup"
  }, React.createElement("div", {
    className: "popup-icon"
  }, React.createElement("img", {
    src: iconImg,
    alt: ""
  })), React.createElement("div", {
    className: "popup-text"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Tap on the measure arrow to see and edit door element's dimensions",
    "id": "components.OverlayManager.DimensionPopup.index.2065830018"
  }, "id", "components.OverlayManager.DimensionPopup.index.2065830018"))), React.createElement("button", {
    className: "popup-btn",
    type: "button",
    onClick: clickHandler
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Okay",
    "id": "components.OverlayManager.DimensionPopup.index.460423030"
  }, "id", "components.OverlayManager.DimensionPopup.index.460423030")))));
};

export default DimensionPopup;